<template>
    <div class="work-order-list">
        <!-- 搜索区域 -->
        <div class="search-wrapper">
            <el-form :model="searchForm" class="search-form" size="small" label-width="auto">
                <!-- 第一行 -->
                <el-row :gutter="20">
                    <el-col :span="6.5">
                        <div class="form-item-wrapper">
                            <span class="label">IMEI</span>
                            <el-input v-model="searchForm.imei" placeholder="请输入IMEI"></el-input>
                        </div>
                    </el-col>
                   
                   <el-col :span="6.5">
                        <div class="form-item-wrapper">
                            <span class="label">当前卡槽</span>
                            <el-input v-model="searchForm.card_slot" placeholder="请输入当前卡槽"></el-input>
                        </div>
                    </el-col>
                    <el-col :span="6.5">
                        <div class="form-item-wrapper">
                            <span class="label">WIFI名称</span>
                            <el-input v-model="searchForm.wifi_name" placeholder="请输入WIFI名称"></el-input>
                        </div>
                    </el-col>
                    <el-col :span="3">
                        <div class="button-row">
                            <el-button type="primary" @click="handleSearch">查询</el-button>
                            <el-button @click="resetSearch">重置</el-button>
                        </div>
                    </el-col>
              </el-row>
          </el-form>
        </div>

        <!-- 表格区域 -->
        <div class="table-section">
            <div class="table-header">
                <div class="header-left">
                    <h3>数据列表</h3>
                    <span class="total-count">共 {{ total }} 条记录</span>
                </div>
                <!-- <div class="header-right">
                    <el-button type="primary" icon="el-icon-plus" @click="$router.push('/service/complaint')">
                        新增数据
                    </el-button>
                </div> -->
            </div>

            <!-- 设备信息卡片列表 -->
            <div v-loading="loading" class="audit-list">
                <div v-if="tableData.length === 0" class="empty-data">
                    <el-empty description="暂无数据"></el-empty>
                </div>
                <template v-else>
                    <el-card v-for="item in tableData" :key="item.id" class="audit-item" shadow="hover">
                        <div class="info-container">
                          
                            <div class="info-content">
                                <el-row :gutter="20">
                                    <el-col :span="6">
                                        <div class="info-item">
                                            <span class="value">
                                                <i class="el-icon-document-copy"></i>
                                                IMEI:{{ item.imei }}
                                            </span>
                                        </div>
                                    </el-col>
                                    <el-col :span="6">
                                        <div class="info-item">
                                            <span class="value">
                                                <i class="el-icon-tickets"></i>
                                                MAC:{{ item.mac }}
                                            </span>
                                        </div>
                                    </el-col>
                                    <el-col :span="6">
                                        <div class="info-item"   size="small" :type="getStatusType(item.wifi_status)"> 
                                          WIFI状态:{{ item.wifi_status }}
                                        </div>
                                    </el-col>
                                    <el-col :span="6">
                                        <div class="info-item">
                                            <span class="value">
                                                <i class="el-icon-document"></i>
                                                当前卡槽：{{ item.card_slot }}
                                            </span>
                                        </div>
                                    </el-col>
                                    <el-col :span="6">
                                        <div class="info-item">
                                            <span class="value">
                                                <i class="el-icon-cpu"></i>
                                                本日已使用流量(MB): {{ item.internet_traffic }}
                                            </span>
                                        </div>
                                    </el-col>
                                    <el-col :span="6.5">
                                        <div class="info-item">
                                            <span class="value">
                                                <i class="el-icon-time"></i>
                                                设备时间：{{ item.current_time}}
                                            </span>
                                        </div>
                                    </el-col>
                                    <el-col :span="6">
                                        <div class="info-item">
                                            <span class="value">
                                                <i class="el-icon-user"></i>
                                                WIFI名称:{{ item.wifi_name }}
                                            </span>
                                        </div>
                                    </el-col>
                                    <el-col :span="5.5">
                                        <div class="info-item">
                                            <span class="value">
                                                <i class="el-icon-office-building"></i>
                                                热点连接数：{{ item.hotspot_connection_count }}
                                            </span>
                                        </div>
                                    </el-col>
                                </el-row>
                                    <el-row :gutter="20">
                                    <el-col :span="6">
                                        <div class="info-item">
                                            <span class="value">
                                                <i class="el-icon-s-custom"></i>
                                                信号强度：{{ item.signal_strength }}
                                            </span>
                                        </div>
                                    </el-col>
                                    <el-col :span="6">
                                        <div class="info-item">
                                            <span class="value">
                                                <i class="el-icon-money"></i>
                                                限速：{{ item.speed_limit }}
                                            </span>
                                        </div>
                                    </el-col>
                                    <el-col :span="6">
                                        <div class="info-item">
                                            <span class="value">
                                                <i class="el-icon-wallet"></i>
                                                版本号：{{ item.version_no }}
                                            </span>
                                        </div>
                                    </el-col>
                                    <el-col :span="6">
                                        <div class="info-item">
                                            <span class="value">
                                                <i class="el-icon-wallet"></i>
                                                IP地址:{{ item.ip_address }}
                                            </span>
                                        </div>
                                    </el-col>
                                </el-row>
                               
                                <el-row>
                                    <el-col :span="24">
                                        <div class="info-item desc-item">
                                            <span class="value">
                                                <i class="el-icon-warning-outline"></i>
                                                问题描述：{{ item.problem}}
                                            </span>
                                        </div>
                                    </el-col>
                                    <el-row>
                                        <el-col :span="24">
                                            <div class="sim-card-table">
                                                <div class="table-title">
                                                    <i class="el-icon-mobile"></i>
                                                    SIM卡信息
                                                </div>
                                                <el-table :data="item.simCards" size="small" border style="width: 100%">
                                                    <el-table-column prop="slot" label="卡槽位" width="100" align="center">
                                                        <template slot-scope="scope">
                                                            <el-tag size="mini" :type="scope.row.slot === 'SIM1' ? 'primary' : 'success'">
                                                                {{ scope.row.slot }}
                                                            </el-tag>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column prop="iccid" label="ICCID" min-width="180" align="center" />
                                                    <el-table-column prop="sim" label="SIM卡号" min-width="150" align="center" />
                                                    <el-table-column prop="realNameStatus" label="实名状态" width="100" align="center">
                                                        <template slot-scope="scope">
                                                            <el-tag size="mini" :type="getRealnameStatusType(scope.row.realNameStatus)">
                                                                {{ scope.row.realNameStatus }}
                                                            </el-tag>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column label="操作" width="150" align="center">
                                                        <template slot-scope="scope">
                                                            <el-button type="text" size="mini" @click="handleSimEdit(scope.row)">
                                                                编辑
                                                            </el-button>
                                                            <el-button type="text" size="mini" @click="handleSimRealname(scope.row)">
                                                                实名认证
                                                            </el-button>
                                                        </template>
                                                    </el-table-column>
                                                </el-table>
                                            </div>
                                        </el-col>
                                    </el-row>
                                    <div class="info-header">
                                <!-- <div class="header-left"> -->
                                    <!-- <span class="order-time">
                                        <i class="el-icon-time"></i>
                                        创建时间：{{ formatRegDateTime(item.create_time) }}
                                    </span> -->
                                    <!-- <span class="creator">
                                        <i class="el-icon-user"></i>
                                        创建人：{{ item.creator || '-' }}
                                    </span> -->
                                    <!-- <el-tag size="small" :type="getStatusType(item.wifi_status)">
                                        WIFI状态:{{ item.wifi_status }}
                                    </el-tag> -->
                                <!-- </div> -->
                                <div class="header-right">
                                    <el-button type="text" size="small" @click="handleEdit(item)">
                                        <i class="el-icon-edit"></i> 编辑
                                    </el-button>
                                </div>
                            </div>

                                </el-row>
                            </div>
                        </div>
                    </el-card>
                </template>
            </div>

            <!-- 分页 -->
            <div class="pagination-container" v-if="total > 0">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[5, 10, 20, 30, 40]" :page-size="5"
                    layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>
 </div>
</template>

<script>
import { getDictData } from '@/api/dict'
import request from '@/utils/request'
import moment from 'moment'

export default {
    name: 'WorkOrderList',
    data() {
        return {
            loading: false,
            total: 3,
            currentPage: 1,
            pageSize: 5,
            searchForm: {
                imei: '',
                card_slot: '',
                wifi_name: ''
            },
            // 保存原始数据
            originalData: [],
            tableData: []
        }
    },
    created() {
        // 初始化数据
        this.initData()
    },
    mounted() {
      
    },
    methods: {
        // 初始化数据
        initData() {
            this.loading = true
            // 模拟数据
            this.originalData = [
                {
                    id: 1,
                    imei: '123456789012345',
                    mac: 'AA:BB:CC:DD:EE:FF',
                    wifi_status: '在线',
                    card_slot: 'SIM1',
                    internet_traffic: 1024,
                    current_time: '2024-03-27 15:30:00',
                    wifi_name: 'Test_WiFi_1',
                    hotspot_connection_count: 5,
                    signal_strength: '-75dBm',
                    speed_limit: '10Mbps',
                    version_no: 'v1.2.3',
                    ip_address: '192.168.1.100',
                    problem: '信号稳定，运行正常',
                    simCards: [
                        {
                            slot: 'SIM1',
                            iccid: '89860432191234567891',
                            sim: '13812345671',
                            realNameStatus: '已实名'
                        },
                        {
                            slot: 'SIM2',
                            iccid: '89860432191234567892',
                            sim: '13812345672',
                            realNameStatus: '未实名'
                        },
                        {
                            slot: 'SIM3',
                            iccid: '89860432191234567893',
                            sim: '13812345673',
                            realNameStatus: '认证中'
                        }
                    ]
                },
                {
                    id: 2,
                    imei: '987654321098765',
                    mac: 'FF:EE:DD:CC:BB:AA',
                    wifi_status: '离线',
                    card_slot: 'SIM2',
                    internet_traffic: 2048,
                    current_time: '2024-03-27 15:35:00',
                    wifi_name: 'Test_WiFi_2',
                    hotspot_connection_count: 3,
                    signal_strength: '-82dBm',
                    speed_limit: '5Mbps',
                    version_no: 'v1.2.4',
                    ip_address: '192.168.1.101',
                    problem: '信号波动较大，需要检查',
                    simCards: [
                        {
                            slot: 'SIM1',
                            iccid: '89860432191234567894',
                            sim: '13812345674',
                            realNameStatus: '已实名'
                        },
                        {
                            slot: 'SIM2',
                            iccid: '89860432191234567895',
                            sim: '13812345675',
                            realNameStatus: '认证失败'
                        },
                        {
                            slot: 'SIM3',
                            iccid: '89860432191234567896',
                            sim: '13812345676',
                            realNameStatus: '未实名'
                        }
                    ]
                },
                {
                    id: 3,
                    imei: '456789012345678',
                    mac: 'BB:CC:DD:EE:FF:AA',
                    wifi_status: '在线',
                    card_slot: 'SIM1',
                    internet_traffic: 3072,
                    current_time: '2024-03-27 15:40:00',
                    wifi_name: 'Test_WiFi_3',
                    hotspot_connection_count: 8,
                    signal_strength: '-68dBm',
                    speed_limit: '20Mbps',
                    version_no: 'v1.2.3',
                    ip_address: '192.168.1.102',
                    problem: '运行正常，性能良好',
                    simCards: [
                        {
                            slot: 'SIM1',
                            iccid: '89860432191234567897',
                            sim: '13812345677',
                            realNameStatus: '已实名'
                        },
                        {
                            slot: 'SIM2',
                            iccid: '89860432191234567898',
                            sim: '13812345678',
                            realNameStatus: '已实名'
                        },
                        {
                            slot: 'SIM3',
                            iccid: '89860432191234567899',
                            sim: '13812345679',
                            realNameStatus: '已实名'
                        }
                    ]
                }
            ]
            // 初始化表格数据
            this.tableData = [...this.originalData]
            this.loading = false
        },
        // 搜索方法修改
        handleSearch() {
            this.loading = true
            setTimeout(() => {
                const searchImei = this.searchForm.imei.toLowerCase()
                const searchCardSlot = this.searchForm.card_slot.toLowerCase()
                const searchWifiName = this.searchForm.wifi_name.toLowerCase()

                // 从原始数据中筛选
                this.tableData = this.originalData.filter(item => {
                    return (!searchImei || item.imei.toLowerCase().includes(searchImei)) &&
                           (!searchCardSlot || item.card_slot.toLowerCase().includes(searchCardSlot)) &&
                           (!searchWifiName || item.wifi_name.toLowerCase().includes(searchWifiName))
                })
                this.loading = false
            }, 500)
        },
        // 重置方法修改
        resetSearch() {
            this.searchForm = {
                imei: '',
                card_slot: '',
                wifi_name: ''
            }
            // 重置为原始数据
            this.tableData = [...this.originalData]
        },
        handleSizeChange(val) {
            this.searchForm.pagesize = val;
            this.getWorkOrderList();
        },
        handleCurrentChange(val) {
            this.searchForm.page = val;
            this.getWorkOrderList();
        },
        async getWorkOrderList() {
            this.loading = true
            try {
                const response = await request({
                    url: '/api/v1/kf-work-order/page',
                    method: 'POST',
                    data: this.searchForm
                })

                console.log('API响应数据：', response) // 添加日志

                if (response.status === 1 && response.data) {
                    this.tableData = response.data.list || []
                    this.total = response.data.total || 0
                    console.log('工单列表数据：', this.tableData) // 添加日志
                } else {
                    this.$message.error(response.message || '获取数据失败')
                }
            } catch (error) {
                console.error('获取工单列表失败:', error)
                this.$message.error('获取数据失败')
            } finally {
                this.loading = false
            }
        },
        formatRegDateTime(time) {
            if (!time) return '--'
            return time.replace('T', ' ').split('+')[0]
        },
        isOverdue(createTime) {
            const now = new Date()
            const createDate = new Date(createTime)
            const diffHours = (now - createDate) / (1000 * 60 * 60)

            return diffHours > 24
        },
        getRowClassName({ row, rowIndex }) {
            if (this.currentPage === 1 &&
                row.status !== '已完结' &&
                this.isOverdue(row.createTime)) {
                return 'overdue-row'
            }
            return ''
        },
        handleView(row) {
            this.currentOrder = row
            this.dialogVisible = true
        },
        handleEdit(row) {
            this.$router.push({
                path: '/service/complaint',
                query: {
                    id: row.work_order_id,
                    type: 'edit'
                }
                
            })
        },
        handleDelete(row) {
            this.$confirm('确认删除该工单?', '提示', {
                type: 'warning'
            }).then(() => {
                this.$message.success('删除成功')
            }).catch(() => { })
        },

        //计算工单流转时长
        calculateFlowTime(createTime) {
            const now = new Date()
            const createDate = new Date(createTime)
            const diffHours = (now - createDate) / (1000 * 60 * 60)
            //大于24小时，显示天数
            if (diffHours > 24) {
                return Math.floor(diffHours / 24) + '天'
            }
            return diffHours.toFixed(2) 
        },

        // getUrgencyType(level) {
        //     const types = {
        //         '紧急': 'danger',
        //         '普通': 'warning',
        //         '低级': 'info'
        //     }
        //     return types[level] || 'info'
        // },
        // getStatusType(status) {
        //     const types = {
        //         '已登记': 'info',
        //         '处理中': 'warning',
        //         '已完结': 'success'
        //     }
        //     return types[status] || 'info'
        // },
        // (createTime) {
        //     if (!createTime) return '-';

        //     const now = new Date();
        //     const create = new Date(createTime);
        //     const diff = now - create;

        //     const hours = Math.floor(diff / (1000 * 60 * 60));

        //     if (hours >= 24) {
        //         return '24小时';
        //     } else {
        //         return `${hours}小时`;
        //     }
        // },
        getStatusType(status) {
            const types = {
                '待处理': 'warning',
                '处理中': 'primary',
                '已完成': 'success',
                '已关闭': 'info'
            }
            return types[status] || 'info'
        },
        getRealnameStatusType(status) {
            switch (status) {
                case '已实名':
                    return 'success'
                case '未实名':
                    return 'warning'
                case '认证中':
                    return 'info'
                case '认证失败':
                    return 'danger'
                default:
                    return 'info'
            }
        },
        handleSimEdit(row) {
            console.log('编辑 SIM 卡:', row)
            this.$message.success('编辑功能开发中...')
        },
        handleSimRealname(row) {
            console.log('实名认证:', row)
            this.$message.success('实名认证功能开发中...')
        }
    }
}
</script>

<style scoped>
.work-order-list {
    min-height: 100%;
    padding: 20px;
    background-color: #f0f5ff;  /* 浅蓝色背景 */
}

.search-wrapper {
    background: #fff;
    padding: 20px;
    margin-bottom: 16px;
}

.search-form {
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

.el-row {
    margin-bottom: 10px;
}

.form-item-wrapper {
    display: flex;
    align-items: center;
    height: 34px;
    padding-left: 80px;
    position: relative;
    margin-bottom: 0;
}

.label {
    position: absolute;
    left: 0;
    color: #606266;
    font-size: 14px;
    white-space: nowrap;
    width: 80px;
    line-height: 32px;
    text-align: right;
    padding-right: 15px;
}

.el-input,
.el-select,
.el-date-editor {
    width: 240px !important;
    flex: none;
    height: 35px !important;
    line-height: 30px;
}

:deep(.el-input__inner) {
    height: 36px !important;
    line-height: 32px;
}

.el-input,
.el-select,
:deep(.el-date-editor) {
    margin-left: 15px;
}

/* 按钮行样式 */
.button-row {
    display: flex;
    justify-content: flex-end;
    height: 32px;
    line-height: 25px;
    padding-left: 20px;
}

/* 调整按钮之间的间距 */
.el-button+.el-button {
    margin-left:10px;
}

/* 行间距 */
.el-row:last-child {
    margin-bottom: 0;
}

.table-section {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
    
    .table-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px;
        border-bottom: 1px solid #e8f0ff;
        background: linear-gradient(to right, #f5f9ff, #fff);
        border-radius: 8px 8px 0 0;

        .header-left {
            display: flex;
            align-items: center;
            gap: 12px;

            h3 {
                font-size: 18px;
                color: #1a1a1a;
                position: relative;
                padding-left: 12px;
                margin: 0;
                display: flex;
                align-items: center;
                
                &:before {
                    content: '';
                    position: absolute;
                    left: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 4px;
                    height: 16px;
                    background: #409EFF;
                    border-radius: 2px;
                }
            }

            .total-count {
                background: #f0f7ff;
                color: #409EFF;
                padding: 4px 12px;
                border-radius: 12px;
                font-size: 13px;
                margin-left: 12px;
                display: inline-flex;
                align-items: center;
                
                &:before {
                    content: '';
                    display: inline-block;
                    width: 4px;
                    height: 4px;
                    background: #409EFF;
                    border-radius: 50%;
                    margin-right: 6px;
                }
            }
        }

        .header-right {
            .el-button {
                padding: 10px 20px;
                border-radius: 4px;
                font-weight: 500;
                transition: all 0.3s ease;
                
                i {
                    margin-right: 6px;
                }

                &:hover {
                    transform: translateY(-1px);
                    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.2);
                }
            }
        }
    }

    .audit-list {
        padding: 20px;
        background: #f8faff;  /* 列表区域稍微深一点的背景色 */
        min-height: 300px;

        .audit-item {
            background: #fff;
            border-radius: 8px;
            margin-bottom: 16px;
            border: 1px solid #e8f0ff;
            transition: all 0.3s ease;
            
            &:hover {
                transform: translateY(-2px);
                box-shadow: 0 8px 16px rgba(64, 158, 255, 0.1);
            }

            .info-container {
                .info-header {
                    background: #f8faff;
                    padding: 16px 20px;
                    border-bottom: 1px solid #e8f0ff;
                }

                .info-content {
                    padding: 20px;

                    .info-item {
                        background: #f8faff;
                        padding: 12px 16px;
                        border-radius: 6px;
                        margin-bottom: 12px;
                        transition: all 0.3s ease;

                        &:hover {
                            background: #f0f7ff;
                        }
                    }
                }
            }
        }
    }
}

/* 分页样式优化 */
.pagination-container {
    padding: 20px;
    background: #fff;
    border-top: 1px solid #e8f0ff;
    border-radius: 0 0 8px 8px;
}

.tech-dialog {
    border-radius: 8px;
    background: linear-gradient(to bottom, #ffffff, #f8faff);
    box-shadow: 0 12px 32px 4px rgba(0, 0, 0, .1);
}

.tech-dialog .el-dialog__header {
    background: linear-gradient(90deg, #f0f2f5, #e6e9f0);
    padding: 20px;
    border-bottom: 1px solid #ebeef5;
    border-radius: 8px 8px 0 0;
}

.tech-dialog .el-dialog__title {
    font-size: 18px;
    color: #2c3e50;
    font-weight: 600;
}

.order-detail {
    max-height: 70vh;
    overflow-y: auto;
    padding: 0 10px;
}

.order-detail::-webkit-scrollbar {
    width: 6px;
}

.order-detail::-webkit-scrollbar-thumb {
    background: #c0c4cc;
    border-radius: 3px;
}

.order-number {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 24px;
    padding: 16px 20px;
    background: #fff;
    border-radius: 8px;
    border: 1px solid #ebeef5;
}

.order-number .number {
    font-size: 20px;
    font-weight: 600;
    color: #2c3e50;
    font-family: 'Monaco', monospace;
}

.detail-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    padding: 0 20px;
}

.section {
    background: #fff;
    border-radius: 4px;
    border: 1px solid #ebeef5;
}

.section-title {
    padding: 12px 15px;
    border-bottom: 1px solid #ebeef5;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 500;
    color: #303133;
    background-color: #fff;
}

.section-title i {
    margin-right: 8px;
    color: #409EFF;
}

.section-content {
    padding: 15px;
    background-color: #fff;
}

.info-item {
    display: flex;
    margin-bottom: 12px;
}

.info-item:last-child {
    margin-bottom: 0;
}

.info-item label {
    width: 100px;
    color: #909399;
    text-align: right;
    padding-right: 12px;
    flex-shrink: 0;
}

.info-item span {
    flex: 1;
    color: #2c3e50;
    text-align: left;
}

.text-left {
    text-align: left !important;
    word-break: break-all;
    white-space: normal;
    line-height: 1.5;
}

.el-tag {
    margin-left: 12px;
}

:deep(.el-tag) {
    border-radius: 4px;
    padding: 0 12px;
    height: 28px;
    line-height: 28px;
    font-weight: 500;
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@media (prefers-color-scheme: dark) {
    .section {
        background: #1e1e1e;
        border-color: #333;
    }

    .info-item label {
        color: #909399;
    }

    .info-item span {
        color: #e0e0e0;
    }
}

.description-text {
    display: inline-block;
    width: 100%;
    
    text-overflow: ellipsis;
    white-space: nowrap;
}

:deep(.el-table__row) {
    line-height: 1.5;
}

:deep(.el-tooltip__popper) {
    max-width: 400px;
    line-height: 1.5;
    padding: 10px;
}

:deep(.el-table) {

    th.el-table__cell,
    td.el-table__cell {
        text-align: center !important;
    }

    .cell {
        text-align: center;
        display: inline-block !important;
        width: 100% !important;
    }
}

.sub-text {
    text-align: center;
    font-size: 12px;
    color: #909399;
    margin-top: 4px;
    width: 100%;
    display: inline-block;
}

.description-text {
    display: inline-block;
    width: 100%;
   
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: left;
}

:deep(.el-table .cell) {
    display: flex;
    justify-content: center;
    align-items: center;
}

:deep(.el-table .cell .el-button--text) {
    margin: 0 5px;
}

.search-form .el-form-item {
    margin-bottom: 0;
    margin-right: 20px;
    text-align: left;
}

.table-header {
    text-align: center;
}

:deep(.el-tag) {
    display: inline-flex;
    justify-content: center;
    align-items: center;
}

:deep(.el-table .cell .el-button-group) {
    display: flex;
    justify-content: center;
    gap: 8px;
}

:deep(.el-tag) {
    display: inline-block;
}

:deep(.el-table__cell .cell .el-button) {
    padding: 0 8px;
}

:deep(.el-table__header-wrapper th) {
    font-weight: 500;
    color: #303133;
}

:deep(.el-table .cell .el-button-group) {
    text-align: center;
    width: 100%;
}

:deep(.el-table__row) {
    height: 50px;
}

.pagination-container {
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #e8f0ff;
    text-align: right;
    display: flex;
    justify-content: flex-end;
}

:deep(.el-pagination) {
    white-space: nowrap;
    padding: 0;
    margin: 0;
    display: flex;
    align-items: center;
}

:deep(.el-pagination__total),
:deep(.el-pagination__sizes) {
    margin-right: 16px;
}

:deep(.el-pager li) {
    margin: 0 4px;
}

.overdue-row {
    background-color: #FFF3F3 !important;
}

.overdue-row:hover>td {
    background-color: #FFE7E7 !important;
}

.el-icon-warning {
    cursor: pointer;
}

.status-text {
    color: #2c3e50;
    font-size: 14px;
    line-height: 1.6;
}

.section {
    background: #fff;
    border-radius: 4px;
    border: 1px solid #ebeef5;
}

.section-content {
    padding: 15px;
    background-color: #fff;
}

.info-item {
    display: flex;
    margin-bottom: 12px;
    align-items: flex-start;
    background-color: #fff;
}

.status-text.processing {
    color: #409EFF;
}

.status-text.completed {
    color: #67C23A;
}

.status-text.pending {
    color: #E6A23C;
}

:deep(.el-table .cell) {
    white-space: nowrap;

    text-overflow: ellipsis;
}

.iccid-column {
    font-family: monospace;
}

.search-form {
    background-color: #fff;
    padding: 15px;
    margin-bottom: 15px;
    border-radius: 4px;
}

.el-form-item {
    margin-bottom: 15px;
}

.el-date-picker {
    width: 260px;
}

.el-select,
.el-cascader {
    width: 240px;
}

/* 调整日期选择器的宽度 */
:deep(.el-date-editor--daterange) {
    width: 100% !important;
}

/* 调整按钮组的位置 */
.operation-btns {
    display: flex;
    justify-content: flex-end;
    height: 100%;
    align-items: center;
}

.operation-btns .el-button {
    margin-left: 10px;
}

/* 专门针对处理类型标签的样式 */
.process-type-label {
    padding-right: 30px !important; /* 增加处理类型标签的右侧间距 */
}

.audit-list {
    margin: 20px 0;
}

.audit-item {
    margin-bottom: 16px;
    
    &:hover {
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    }
}

.info-container {
    .info-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;
        padding-bottom: 12px;
        border-bottom: 1px solid #ebeef5;

        .header-left {
            display: flex;
            align-items: center;
            gap: 12px;

            .order-time, .creator {
                background: #f5f7fa;
                padding: 6px 12px;
                border-radius: 4px;
                color: #606266;
                font-size: 13px;
                display: inline-flex;
                align-items: center;
                gap: 4px;
                
                i {
                    color: #409EFF;
                    font-size: 14px;
                }
            }

            .creator {
                i {
                    color: #67C23A;  
                }
            }
        }
    }

    .info-content {
        .info-item {
            margin-bottom: 12px;
            
            .label {
                color: #909399;
                margin-right: 8px;
            }
            
            .value {
                color: #303133;
                font-weight: 500;
            }
            
            .sub-text {
                color: #909399;
                font-size: 12px;
                margin-left: 8px;
            }
        }
    }
}

.el-card {
    border-radius: 8px;
    
    &:hover {
        transition: all 0.3s;
    }
}

.el-tag {
    border-radius: 4px;
}

.empty-data {
    padding: 40px 0;
    text-align: center;
}

.info-item {
    .value {
        i {
            font-size: 16px;
            margin-right: 8px;

            /* 图标颜色定制 */
            &.el-icon-tickets {
                color: #409EFF;  
            }
            
            &.el-icon-document {
                color: #67C23A;  
            }
            
            &.el-icon-cpu {
                color: #E6A23C; 
            }
            
            &.el-icon-time {
                color: #909399; 
            }
            
            &.el-icon-user {
                color: #F56C6C; 
            }
            
            &.el-icon-office-building {
                color: #9C27B0;  
            }
            
            &.el-icon-s-custom {
                color: #2196F3;  
            }
            
            &.el-icon-money {
                color: #4CAF50;  
            }
            
            &.el-icon-warning-outline {
                color: #FF9800;  
            }
            &.el-icon-document-copy {
                color: #1976D2; 
            }
            &.el-icon-wallet {
                color: #795548; 
            }
        }
    }
}

/* 问题描述区域特殊样式 */
.desc-item {
    background: #fff8f0 !important;
    border-left: 4px solid #FF9800;
    
    .value {
        i {
            color: #FF9800 !important;
        }
    }
}
.el-main{
    background-color: #6993e7;
}

.sim-card-table {
  margin-top: 16px;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 4px;

  .table-title {
    margin-bottom: 12px;
    font-size: 14px;
    font-weight: 500;
    color: #303133;
    display: flex;
    align-items: center;

    i {
      margin-right: 8px;
      color: #409EFF;
    }
  }

  .el-table {
    margin-bottom: 0;
  }

  :deep(.el-button--text) {
    padding: 0 8px;
  }

  :deep(.el-tag--mini) {
    padding: 0 8px;
    height: 20px;
    line-height: 18px;
  }
}
</style>
